import React, { SVGProps } from 'react';

export const ArrowRight001Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg width={14} height={8} fill="none" preserveAspectRatio="none" {...props}>
    <path
      d="M13.605 4.354a.5.5 0 0 0 0-.708L10.423.464a.5.5 0 1 0-.707.708L12.544 4 9.716 6.828a.5.5 0 1 0 .707.708l3.182-3.182ZM.32 4.5h12.93v-1H.321v1Z"
      fill="#000"
    />
  </svg>
);
